// A point's normal band (VisionPlatform device-dashboards DDB-01, DDB-03). widget-fixture 0.1.0 has no
// `PointState.expected` yet (0.2.0 adds it, DDB-05), so the device page puts it on the point and this reads it
// defensively.
import type { PointState } from "./generated/widget-fixture";

export type Band = readonly [number, number];

export function expectedOf(point: PointState | undefined): Band | undefined {
  return toBand((point as { expected?: unknown } | undefined)?.expected);
}

/** `[low, high]` with low below high, or nothing. */
export function toBand(v: unknown): Band | undefined {
  if (!Array.isArray(v) || v.length !== 2) return undefined;
  const [low, high] = v as unknown[];
  return typeof low === "number" && typeof high === "number" && low < high ? [low, high] : undefined;
}

/** A number outside the point's band; false without a band or a number. */
export function outsideExpected(point: PointState | undefined, value: unknown): boolean {
  const band = expectedOf(point);
  return !!band && typeof value === "number" && (value < band[0] || value > band[1]);
}

export type GaugeBand = { to: number; level: "ok" | "warning" | "critical" };

/** Gauge bands from the band when the widget's config gives none: warning, ok inside, warning; clipped to the dial. */
export function gaugeBands(band: Band | undefined, min: number, max: number): GaugeBand[] {
  if (!band || max <= min) return [];
  const low = Math.min(Math.max(band[0], min), max);
  const high = Math.min(Math.max(band[1], min), max);
  const out: GaugeBand[] = [];
  if (low > min) out.push({ to: low, level: "warning" });
  if (high > low) out.push({ to: high, level: "ok" });
  if (max > high) out.push({ to: max, level: "warning" });
  return out;
}
